export default __webpack_public_path__ + "static/media/balance-sheet-and-capital-structure-2.d10d97db.png";